import { Component, OnInit, Input } from '@angular/core';
import { FormatoAsistencialEntity, FiltrosFormatoAsistencialEntity, NodoEntity, ServicioFormatoAsistencialService } from 'src/app/services/servicio-formato-asistencial.service';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Component({
  selector: 'app-condicion',
  templateUrl: './condicion.component.html',
  styleUrls: ['./condicion.component.css']
})
export class CondicionComponent implements OnInit {

  @Input() data: FormatoAsistencialEntity;
  @Input() filtros: FiltrosFormatoAsistencialEntity;
  @Input() nodo: NodoEntity;

  titulo: string;
  error = false;
  loading: boolean;
  items: any[];
  positions: { start: number, end: number }[];

  private HEADERS = new HttpHeaders ({ 'Content-Type' : 'application/json'});

  constructor( private http: HttpClient,
               private servicioFormato: ServicioFormatoAsistencialService) { }

  ngOnInit() {
    if (this.nodo && this.filtros) {
      this.onProcess();
    } else {
      this.titulo = '';
    }
  }

  onProcess() {
    this.titulo = this.nodo.titulo;
    this.error = false;
    this.items = [];
    this.getCondicionValue();
  }

  async getCondicionValue() {
    this.positions = [];
    this.loading = true;
    this.error = false;
    this.servicioFormato.setTemporalWait(this.nodo, true);
    const url = `${environment.API_REPORTES}/formato-asistencial/condicion`;
    const body: any = {
      codigoBaseDatos: this.filtros.codigoBaseDatos,
      tta: this.filtros.tta,
      nodo: {
        id: this.nodo.id
      }
    };

    try {
      const request = await this.http.post(url, body, { headers : this.HEADERS});
      if (request) {
        request.subscribe((items: any[]) => {
          if (items && items.length > 0) {
            items.forEach((item: any) => {
              const it: any = {
                title: item.nodo.titulo,
                value: item.value,
              };

              const cantidad = this.getCantidadItems(item.conditionValue, 0);
              if (cantidad > 0) {
                const strs: string[] = this.getStringsItems(item.conditionValue);
                const conditions = this.getConditionItems(strs);
                it.conditions = conditions;
              }
              this.items.push(it);
              this.loading = false;
              this.error = false;
              this.servicioFormato.setTemporalWait(this.nodo, false);

              if (this.filtros.diligenciados) {
                const validateEmpty = this.validateEmptyResponse(items);
                if (validateEmpty) {
                  this.onDelete();
                }
              }
            });
          } else {
            this.items = [];
            this.loading = false;
            this.error = false;
            this.servicioFormato.setTemporalWait(this.nodo, false);
            if (this.filtros.diligenciados) {
              const validateEmpty = this.validateEmptyResponse(items);
              if (validateEmpty) {
                this.onDelete();
              }
            }
          }
        }, (err: any) => {
          console.error('Error Condicion.getConditionValue(): ', err);
          this.loading = false;
          this.error = true;
          this.servicioFormato.setTemporalWait(this.nodo, false);
        });
      } else {
        this.loading = false;
        this.error = true;
        this.servicioFormato.setTemporalWait(this.nodo, false);
      }
    } catch (e) {
      console.error('Catch Request', this.nodo.id);
      this.loading = false;
      this.error = true;
      this.servicioFormato.setTemporalWait(this.nodo, false);
    }
  }

  // Obtiene la cantidad de items condition
  getCantidadItems(cv: string, start: number): number {
    if (cv && cv.includes('<span class="block">', start)) {
      const indexOf = cv.indexOf('<span class="block">', start);
      this.positions.push({start : start, end: indexOf});
      return this.getCantidadItems(cv, indexOf + 1) + 1;
    } else {
      return 0;
    }
  }

  // Obtiene los string condicion de cada uno.
  getStringsItems(cv: string): string[] {
    const strs: string[] = [];
    for (let i = 0; i < this.positions.length; i++) {
      const pos = this.positions[i];
      if (i === (this.positions.length - 1)) {
        const newStr = cv.slice(pos.end, cv.length);
        strs.push(newStr);
      } else {
        const nextPos = this.positions[i + 1];
        const newStr = cv.slice(pos.end, nextPos.end);
        strs.push(newStr);
      }
    }
    return strs;
  }

  getConditionItems(strs: string[]): { value: string, style: any}[] {
    const els: any[] = [];
    for (let i = 0; i < strs.length; i++) {
      const str = strs[i];
      const style = this.getStyleCondition(str);
      const styleObj = this.convertStyleCondition(style);
      els.push({
        value : str,
        style : styleObj
      });
    }
    return els;
  }

  // Obtener estilos generales de la condicion
  getStyleCondition(cv: string) {
    if (cv) {
      if (cv.includes('style')) {
        const index = cv.indexOf('style');
        const v1 = cv.slice(index, cv.length);
        const v2 = v1.split('style=');
        const v3 = v2[1].split('"');
        return v3[1];
      }
    }
    return null;
  }

  convertStyleCondition(style: string): any {
    const styles: any = {
      'background-color' : '',
      'font-size' : ''
    };

    const bg = this.getPropertyValue('background-color', style);
    if (bg) { styles['background-color'] = bg; }

    const fs = this.getPropertyValue('font-size', style);
    if (fs) { styles['font-size'] = fs; }

    return styles;
  }

  getPropertyValue(prop: string, style: string): string {
    if (style && style.includes(prop)) {
      const startPos = style.indexOf(prop);
      const subStyle = style.substring((startPos + prop.length), style.length);
      if (subStyle && subStyle.length > 0) {
        if (subStyle.charAt(0) === ':') {
          let newStyle = '';
          for (let i = 1; i < subStyle.length; i++) {
            const chart = subStyle.charAt(i);
            if (chart === ';') {
              break;
            } else {
              newStyle += chart;
            }
          }
          return newStyle;
        }
      }
    }
    return null;
  }
  
  validateEmptyResponse(items: any[]): boolean {
    let isEmpty = true;
    if (items && items.length > 0){
      items.forEach((item: any) => {
        if (item && item.valor && item.valor != '0' && item.valor != '0.0'){
          isEmpty = false;
        }
      })
    }

    return isEmpty;
  }

  onDelete() {}

}
